import { SectionStatusServant } from './section_status_servant';
import { ICrossCourseCorequisitesDatasource } from '../../../components/section_corequisite/datasources/cross_course_corequisite_datasource';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import { ScheduledSectionStatus } from '../types/scheduled_section_status_enum';
import { SectionTileErrorEnum } from '../types/section_tile_error_enum';
import { ISectionsDatasource } from '../../sections/datasources/sections_datasource';
import { TermScheduleFlags } from '../services/term_schedule_flags';
import * as _4 from 'lodash4';
import { TermCourse } from '../../term_courses/builders/term_course_builder';

export class ScheduledSectionStatusServant {
  sectionStatus = SectionStatusServant.sectionStatus;

  hasStatus = SectionStatusServant.hasStatus;

  isCompleted = SectionStatusServant.isCompleted;

  isStatusCompleted = SectionStatusServant.isStatusCompleted;

  isStatusPending = SectionStatusServant.isStatusPending;

  isStatusFailed = SectionStatusServant.isStatusFailed;

  isStatusFailedDrop = SectionStatusServant.isStatusFailedDrop;

  isStatusRegistered = SectionStatusServant.isStatusRegistered;

  isStatusInProgress = SectionStatusServant.isStatusInProgress;

  isRegisteredOrInprogress = SectionStatusServant.isRegisteredOrInprogress;

  isStatusWaitlisted = SectionStatusServant.isStatusWaitlisted;

  isStatusWithdrawn = SectionStatusServant.isStatusWithdrawn;

  isStatusWaitlistFailed = SectionStatusServant.isStatusWaitlistFailed;

  isStatusWaitlistDropFailed = SectionStatusServant.isStatusWaitlistDropFailed;

  isStatusUnscheduled = SectionStatusServant.isStatusUnscheduled;

  isStatusRegisteredOrCompleteOrInProgress = SectionStatusServant.isStatusRegisteredOrCompleteOrInProgress;
  constructor(
    private ngSectionsDatasource: ISectionsDatasource,
    private ngCrossCourseCorequisitesDatasource: ICrossCourseCorequisitesDatasource,
    private ngTermScheduleFlags: TermScheduleFlags
  ) {}

  isSectionScheduled(section: ISection): boolean {
    return _4.includes(ScheduledSectionStatus.getScheduledSectionStatuses(), section.status);
  }

  getCrossCourseCorequisites(section: ISection) {
    const corequisiteCourseEntry = this.ngCrossCourseCorequisitesDatasource.get(section.id);
    if (corequisiteCourseEntry) {
      return corequisiteCourseEntry.course_corequisites;
    }
    return [];
  }

  hasDropDates(section: ISection): boolean {
    return !_4.isNull(section.drop_start_dt) && !_4.isNull(section.drop_end_dt);
  }

  isDroppable(section: ISection): boolean {
    const canDropByDateLogic = moment().isBefore(moment(section.drop_end_dt, 'YYYY-MM-DD'));
    return _4.get(section, 'is_droppable', canDropByDateLogic);
  }

  canWithdraw(section: ISection): boolean {
    const dropEndDate = moment(section.drop_end_dt, 'YYYY-MM-DD');
    const canWithdrawLogic =
      moment().isAfter(dropEndDate) && moment().isBefore(moment(section.withdraw_end_dt, 'YYYY-MM-DD'));
    return _4.get(section, 'can_withdraw', canWithdrawLogic) && !this.isStatusWithdrawn(section);
  }

  isOnline(section: ISection) {
    return section._campus.is_online;
  }
  isBlended(section: ISection) {
    const isBlended = /(blended|partial)/gi.test(section._campus.name);
    return isBlended;
  }

  isValidFailureForCurrentStatus(section: ISection, failureType: string) {
    return !(this.isStatusRegistered(section) && _4.isEqual(failureType, SectionTileErrorEnum.ADD));
  }

  isCoreqEnforcementEnabled() {
    return this.ngTermScheduleFlags.isCoreqEnforcementEnabled();
  }

  hasEnforcedCoreqs(section: ISection) {
    const coreqCoursesInSection = _4.get(section, '_course._coreq_courses', []);
    return this.ngTermScheduleFlags.isCoreqEnforcementEnabled() && !_4.isEmpty(coreqCoursesInSection);
  }

  hasEnforcedCoreqsNotScheduled(section: ISection) {
    if (!this.isCoreqEnforcementEnabled()) {
      return false;
    }
    const coreqCoursesInSection = _4.get(section, '_course._coreq_courses', []);

    const coreqsAlreadyScheduled = _4.map(coreqCoursesInSection, (coreqCourseInSection: TermCourse) =>
      _4.find(
        _4.toArray(this.ngSectionsDatasource.read()),
        (coreqCourse: ISection) =>
          coreqCourse.course === coreqCourseInSection.id &&
          _4.includes([ScheduledSectionStatus.SECTION_PICKED, ScheduledSectionStatus.REGISTERED], coreqCourse.status)
      )
    );

    return _4.size(coreqCoursesInSection) > _4.size(_4.compact(coreqsAlreadyScheduled));
  }

  getInProgressSections() {
    return _4.filter(_4.toArray(this.ngSectionsDatasource.read()), (sec) => this.isStatusInProgress(sec));
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/servants/scheduled_section_status_servant.ts